import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { WidgetAISidebar, GiadaAvatar } from '../ai';
import { TrendingUp, AlertTriangle, Sparkles, Lightbulb } from 'lucide-react';
interface RedemptionsByTypeChartProps {
  data: {
    type: string;
    count: number;
    image?: string;
  }[];
}
const RedemptionsByTypeChart: React.FC<RedemptionsByTypeChartProps> = ({
  data
}) => {
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const suggestions = [{
    id: '1',
    category: 'Opportunità',
    title: 'Cosmetici Solidi in forte crescita',
    description: "I cosmetici solidi rappresentano il 28% dei riscatti (+25% vs periodo precedente). Aumenta l'offerta in questa categoria per capitalizzare il trend.",
    icon: TrendingUp
  }, {
    id: '2',
    category: 'Rischio',
    title: 'Buoni sconto sotto-performanti',
    description: 'Solo 15% dei riscatti totali. Gli utenti preferiscono prodotti fisici. Considera di ridurre i buoni sconto del 30% e investire in prodotti.',
    icon: AlertTriangle
  }, {
    id: '3',
    category: 'Strategia',
    title: 'Esperienze ad alto valore',
    description: 'Workshop e consulenze hanno conversion rate 2x superiore alla media. Crea più esperienze simili (es. consulenze personalizzate, masterclass).',
    icon: Sparkles
  }];
  // Color palette for different reward types
  const COLORS = ['#1a4d2e', '#2d7a4f', '#4aa770', '#7bc99c', '#a8ddb5', '#c7e9c0' // Pale green
  ];
  // Calculate total for percentages
  const total = data.reduce((sum, entry) => sum + entry.count, 0);
  // Custom label to show percentage
  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }: any) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent < 0.05) return null; // Don't show label for very small slices
    return <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={12} fontWeight="600" data-id="element-341">
        {`${(percent * 100).toFixed(0)}%`}
      </text>;
  };
  // Custom tooltip
  const CustomTooltip = ({
    active,
    payload
  }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = (data.value / total * 100).toFixed(1);
      return <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-lg" data-id="element-342">
          <p className="font-semibold text-gray-900 mb-1" data-id="element-343">{data.name}</p>
          <p className="text-sm text-gray-600" data-id="element-344">
            Riscatti: <span className="font-medium" data-id="element-345">{data.value}</span>
          </p>
          <p className="text-sm text-gray-600" data-id="element-346">
            Percentuale: <span className="font-medium" data-id="element-347">{percentage}%</span>
          </p>
        </div>;
    }
    return null;
  };
  // Custom legend
  const renderLegend = (props: any) => {
    const {
      payload
    } = props;
    return <div className="flex flex-wrap justify-center gap-3 mt-4" data-id="element-348">
        {payload.map((entry: any, index: number) => <div key={`legend-${index}`} className="flex items-center gap-2" data-id="element-349">
            <div className="w-3 h-3 rounded-full" style={{
          backgroundColor: entry.color
        }} data-id="element-350" />
            <span className="text-xs text-gray-600" data-id="element-351">{entry.value}</span>
          </div>)}
      </div>;
  };
  return <>
      <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-352">
        <div className="flex items-center justify-between mb-4" data-id="element-353">
          <h3 className="text-lg font-semibold" data-id="element-354">Riscatti per Tipo Premio</h3>
          <div style={{
          background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
          padding: '2px',
          borderRadius: '100px'
        }} data-id="element-355">
            <button onClick={() => setIsAISidebarOpen(true)} className="text-black transition-colors flex items-center gap-1.5 bg-white px-3 py-1.5 hover:bg-gray-50" style={{
            borderRadius: '100px'
          }} title="AI Insights" data-id="element-356">
              <span className="text-sm" data-id="element-357">Suggerimenti AI</span>
            </button>
          </div>
        </div>
        <div className="h-80" data-id="element-358">
          <ResponsiveContainer width="100%" height="100%" data-id="element-359">
            <PieChart data-id="element-360">
              <Pie data={data} cx="50%" cy="50%" labelLine={false} label={renderCustomLabel} outerRadius={120} fill="#8884d8" dataKey="count" nameKey="type" data-id="element-361">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-362" />)}
              </Pie>
              <Tooltip content={<CustomTooltip data-id="element-364" />} data-id="element-363" />
              <Legend content={renderLegend} data-id="element-365" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <WidgetAISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} widgetInfo={{
      title: 'Riscatti per Tipo Premio',
      description: 'Analisi AI della distribuzione dei riscatti per categoria di premio, con identificazione di opportunità e rischi.'
    }} suggestions={suggestions} data-id="element-366" />
    </>;
};
export default RedemptionsByTypeChart;